let isEnabled: any;
function checkIfCanalPlusEnabled() {
    if (typeof isEnabled !== 'undefined') {
        return isEnabled;
    }

    try {
        const isFeatureEnabled =
            window.dazn.features.isEnabledAnonymous('f_ar_enable_canal_plus');
        isEnabled = isFeatureEnabled;
        return isFeatureEnabled;
    } catch (e) {
        return false;
    }
}

let canalPlusPartnerUrl: any;
function getCanalPlusParterRedirectUrl() {
    if (canalPlusPartnerUrl !== undefined)
        return canalPlusPartnerUrl;
    try {
        canalPlusPartnerUrl =
            window.dazn.features.getVariableStringAnonymous(
                'f_ar_enable_canal_plus',
                'canal_plus_partner_redirect_url'
            );
        return canalPlusPartnerUrl;
    } catch (e) {
        return '';
    }
}



export {
    checkIfCanalPlusEnabled,
    getCanalPlusParterRedirectUrl,
};
